"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function ClientExceptionEntityFromJSON(json) {
    return ClientExceptionEntityFromJSONTyped(json, false);
}
exports.ClientExceptionEntityFromJSON = ClientExceptionEntityFromJSON;
function ClientExceptionEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detail': !runtime_1.exists(json, 'detail') ? undefined : json['detail'],
        'error': !runtime_1.exists(json, 'error') ? undefined : json['error'],
        'exception': !runtime_1.exists(json, 'exception') ? undefined : json['exception'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
        'path': !runtime_1.exists(json, 'path') ? undefined : json['path'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'timestamp': !runtime_1.exists(json, 'timestamp') ? undefined : json['timestamp'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
    };
}
exports.ClientExceptionEntityFromJSONTyped = ClientExceptionEntityFromJSONTyped;
function ClientExceptionEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detail': value.detail,
        'error': value.error,
        'exception': value.exception,
        'message': value.message,
        'path': value.path,
        'status': value.status,
        'timestamp': value.timestamp,
        'type': value.type,
    };
}
exports.ClientExceptionEntityToJSON = ClientExceptionEntityToJSON;
/**
* @export
* @enum {string}
*/
var ClientExceptionEntityTypeEnum;
(function (ClientExceptionEntityTypeEnum) {
    ClientExceptionEntityTypeEnum["UNSPECIFIEDSERVERERROR"] = "UNSPECIFIED_SERVER_ERROR";
    ClientExceptionEntityTypeEnum["SENDSMSFAILED"] = "SEND_SMS_FAILED";
    ClientExceptionEntityTypeEnum["SENDEMAILFAILED"] = "SEND_EMAIL_FAILED";
    ClientExceptionEntityTypeEnum["PUSHFAILED"] = "PUSH_FAILED";
    ClientExceptionEntityTypeEnum["PUSHMESSAGEINVALID"] = "PUSH_MESSAGE_INVALID";
    ClientExceptionEntityTypeEnum["DATAINITIALIZATIONFAILED"] = "DATA_INITIALIZATION_FAILED";
    ClientExceptionEntityTypeEnum["TEAMNOTIFICATIONCONNECTIONCONFIGINVALID"] = "TEAM_NOTIFICATION_CONNECTION_CONFIG_INVALID";
    ClientExceptionEntityTypeEnum["FILESTORAGEFAILED"] = "FILE_STORAGE_FAILED";
    ClientExceptionEntityTypeEnum["INVALIDFEATURECONFIGURATION"] = "INVALID_FEATURE_CONFIGURATION";
    ClientExceptionEntityTypeEnum["REFLECTIONFAILED"] = "REFLECTION_FAILED";
    ClientExceptionEntityTypeEnum["UNSPECIFIEDNOTFOUND"] = "UNSPECIFIED_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TENANTNOTFOUND"] = "TENANT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["GEOAREANOTFOUND"] = "GEO_AREA_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PERSONNOTFOUND"] = "PERSON_NOT_FOUND";
    ClientExceptionEntityTypeEnum["OAUTHACCOUNTNOTFOUND"] = "OAUTH_ACCOUNT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["SHOPNOTFOUND"] = "SHOP_NOT_FOUND";
    ClientExceptionEntityTypeEnum["APPNOTFOUND"] = "APP_NOT_FOUND";
    ClientExceptionEntityTypeEnum["APPVARIANTNOTFOUND"] = "APP_VARIANT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["OAUTHCLIENTNOTFOUND"] = "OAUTH_CLIENT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["ROLENOTFOUND"] = "ROLE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["RELATEDENTITYNOTFOUND"] = "RELATED_ENTITY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["MEDIAITEMNOTFOUND"] = "MEDIA_ITEM_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TEMPORARYMEDIAITEMNOTFOUND"] = "TEMPORARY_MEDIA_ITEM_NOT_FOUND";
    ClientExceptionEntityTypeEnum["LEGALTEXTNOTFOUND"] = "LEGAL_TEXT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["NEWSSOURCENOTFOUND"] = "NEWS_SOURCE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["DEFAULTMEDIAITEMNOTFOUND"] = "DEFAULT_MEDIA_ITEM_NOT_FOUND";
    ClientExceptionEntityTypeEnum["CONTACTPERSONNOTFOUND"] = "CONTACT_PERSON_NOT_FOUND";
    ClientExceptionEntityTypeEnum["FEATURENOTFOUND"] = "FEATURE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PERSONWITHEMAILNOTFOUND"] = "PERSON_WITH_EMAIL_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PERSONWITHOAUTHIDNOTFOUND"] = "PERSON_WITH_OAUTH_ID_NOT_FOUND";
    ClientExceptionEntityTypeEnum["DELIVERYNOTFOUND"] = "DELIVERY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["INTELLIGENTCONTAINERNOTFOUND"] = "INTELLIGENT_CONTAINER_NOT_FOUND";
    ClientExceptionEntityTypeEnum["POOLINGSTATIONBOXNOTFOUND"] = "POOLING_STATION_BOX_NOT_FOUND";
    ClientExceptionEntityTypeEnum["POOLINGSTATIONNOTFOUND"] = "POOLING_STATION_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PURCHASEORDERNOTFOUND"] = "PURCHASE_ORDER_NOT_FOUND";
    ClientExceptionEntityTypeEnum["RECEIVERPICKUPASSIGNMENTNOTFOUND"] = "RECEIVER_PICKUP_ASSIGNMENT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TRANSPORTALTERNATIVEBUNDLENOTFOUND"] = "TRANSPORT_ALTERNATIVE_BUNDLE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TRANSPORTALTERNATIVENOTFOUND"] = "TRANSPORT_ALTERNATIVE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TRANSPORTASSIGNMENTNOTFOUND"] = "TRANSPORT_ASSIGNMENT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TRANSPORTASSIGNMENTORALTERNATIVENOTFOUND"] = "TRANSPORT_ASSIGNMENT_OR_ALTERNATIVE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["TRANSPORTCONFIRMATIONNOTFOUND"] = "TRANSPORT_CONFIRMATION_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PUSHENDPOINTNOTFOUND"] = "PUSH_ENDPOINT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PUSHTOPICNOTFOUND"] = "PUSH_TOPIC_NOT_FOUND";
    ClientExceptionEntityTypeEnum["PUSHCATEGORYNOTFOUND"] = "PUSH_CATEGORY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["CHATNOTFOUND"] = "CHAT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["ACCOUNTNOTFOUND"] = "ACCOUNT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["ACCOUNTENTRYNOTFOUND"] = "ACCOUNT_ENTRY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["KEYNOTFOUND"] = "KEY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["SELLINGPOINTNOTFOUND"] = "SELLING_POINT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["SELLINGVEHICLENOTFOUND"] = "SELLING_VEHICLE_NOT_FOUND";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGNOTFOUND"] = "USER_GENERATED_CONTENT_FLAG_NOT_FOUND";
    ClientExceptionEntityTypeEnum["ENDPOINTNOTFOUND"] = "ENDPOINT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["POSTNOTFOUND"] = "POST_NOT_FOUND";
    ClientExceptionEntityTypeEnum["COMMENTNOTFOUND"] = "COMMENT_NOT_FOUND";
    ClientExceptionEntityTypeEnum["POSTNOTLIKED"] = "POST_NOT_LIKED";
    ClientExceptionEntityTypeEnum["COMMENTNOTLIKED"] = "COMMENT_NOT_LIKED";
    ClientExceptionEntityTypeEnum["TRADINGCATEGORYNOTFOUND"] = "TRADING_CATEGORY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["SUGGESTIONCATEGORYNOTFOUND"] = "SUGGESTION_CATEGORY_NOT_FOUND";
    ClientExceptionEntityTypeEnum["GROUPNOTFOUND"] = "GROUP_NOT_FOUND";
    ClientExceptionEntityTypeEnum["ACHIEVEMENTLEVELNOTFOUND"] = "ACHIEVEMENT_LEVEL_NOT_FOUND";
    ClientExceptionEntityTypeEnum["UNSPECIFIEDBADREQUEST"] = "UNSPECIFIED_BAD_REQUEST";
    ClientExceptionEntityTypeEnum["EVENTATTRIBUTEINVALID"] = "EVENT_ATTRIBUTE_INVALID";
    ClientExceptionEntityTypeEnum["QUERYPARAMETERINVALID"] = "QUERY_PARAMETER_INVALID";
    ClientExceptionEntityTypeEnum["PAGEPARAMETERINVALID"] = "PAGE_PARAMETER_INVALID";
    ClientExceptionEntityTypeEnum["SEARCHPARAMETERTOOSHORT"] = "SEARCH_PARAMETER_TOO_SHORT";
    ClientExceptionEntityTypeEnum["CONCURRENTREQUESTFAILED"] = "CONCURRENT_REQUEST_FAILED";
    ClientExceptionEntityTypeEnum["INVALIDADMINTASKPARAMETERS"] = "INVALID_ADMIN_TASK_PARAMETERS";
    ClientExceptionEntityTypeEnum["FEATURENOTENABLED"] = "FEATURE_NOT_ENABLED";
    ClientExceptionEntityTypeEnum["RELATEDENTITYMUSTNOTBENULL"] = "RELATED_ENTITY_MUST_NOT_BE_NULL";
    ClientExceptionEntityTypeEnum["MEDIAITEMUPLOADFAILED"] = "MEDIA_ITEM_UPLOAD_FAILED";
    ClientExceptionEntityTypeEnum["MEDIAITEMDUPLICATEUSAGE"] = "MEDIA_ITEM_DUPLICATE_USAGE";
    ClientExceptionEntityTypeEnum["TEMPORARYMEDIAITEMLIMITEXCEEDED"] = "TEMPORARY_MEDIA_ITEM_LIMIT_EXCEEDED";
    ClientExceptionEntityTypeEnum["TEMPORARYMEDIAITEMDUPLICATEUSAGE"] = "TEMPORARY_MEDIA_ITEM_DUPLICATE_USAGE";
    ClientExceptionEntityTypeEnum["PERSONINFORMATIONINVALID"] = "PERSON_INFORMATION_INVALID";
    ClientExceptionEntityTypeEnum["PERSONPARAMETERSINVALID"] = "PERSON_PARAMETERS_INVALID";
    ClientExceptionEntityTypeEnum["ACCOUNTTYPEINVALID"] = "ACCOUNT_TYPE_INVALID";
    ClientExceptionEntityTypeEnum["GEOAREAISNOLEAF"] = "GEO_AREA_IS_NO_LEAF";
    ClientExceptionEntityTypeEnum["BLOCKEDPERSONSLIMITEXCEEDED"] = "BLOCKED_PERSONS_LIMIT_EXCEEDED";
    ClientExceptionEntityTypeEnum["APPVARIANTUSAGEINVALID"] = "APP_VARIANT_USAGE_INVALID";
    ClientExceptionEntityTypeEnum["PLATFORMNOTSUPPORTED"] = "PLATFORM_NOT_SUPPORTED";
    ClientExceptionEntityTypeEnum["PUSHCATEGORYNOTCONFIGURABLE"] = "PUSH_CATEGORY_NOT_CONFIGURABLE";
    ClientExceptionEntityTypeEnum["ADDRESSINVALID"] = "ADDRESS_INVALID";
    ClientExceptionEntityTypeEnum["ADDRESSLISTENTRYINVALID"] = "ADDRESS_LIST_ENTRY_INVALID";
    ClientExceptionEntityTypeEnum["PURCHASEORDERINVALID"] = "PURCHASE_ORDER_INVALID";
    ClientExceptionEntityTypeEnum["WRONGTRACKINGCODE"] = "WRONG_TRACKING_CODE";
    ClientExceptionEntityTypeEnum["CHATMESSAGEINVALID"] = "CHAT_MESSAGE_INVALID";
    ClientExceptionEntityTypeEnum["CHATNOTUNIQUEBYSUBJECT"] = "CHAT_NOT_UNIQUE_BY_SUBJECT";
    ClientExceptionEntityTypeEnum["UNKNOWNPERSONORDERPOOLINGSTATION"] = "UNKNOWN_PERSON_ORDER_POOLING_STATION";
    ClientExceptionEntityTypeEnum["CATEGORYNAMEINVALID"] = "CATEGORY_NAME_INVALID";
    ClientExceptionEntityTypeEnum["KEYNAMEINVALID"] = "KEY_NAME_INVALID";
    ClientExceptionEntityTypeEnum["SCOREEXCHANGEAMOUNTINVALID"] = "SCORE_EXCHANGE_AMOUNT_INVALID";
    ClientExceptionEntityTypeEnum["GROUPCANNOTBEDELETED"] = "GROUP_CANNOT_BE_DELETED";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGALREADYEXISTS"] = "USER_GENERATED_CONTENT_FLAG_ALREADY_EXISTS";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGENTITYCANNOTBEDELETED"] = "USER_GENERATED_CONTENT_FLAG_ENTITY_CAN_NOT_BE_DELETED";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGSTATUSCHANGEINVALID"] = "USER_GENERATED_CONTENT_FLAG_STATUS_CHANGE_INVALID";
    ClientExceptionEntityTypeEnum["POSTIMAGELIMITEXCEEDED"] = "POST_IMAGE_LIMIT_EXCEEDED";
    ClientExceptionEntityTypeEnum["COMMENTIMAGELIMITEXCEEDED"] = "COMMENT_IMAGE_LIMIT_EXCEEDED";
    ClientExceptionEntityTypeEnum["POSTINVALID"] = "POST_INVALID";
    ClientExceptionEntityTypeEnum["INVALIDSORTINGCRITERION"] = "INVALID_SORTING_CRITERION";
    ClientExceptionEntityTypeEnum["INVALIDFILTERCRITERIA"] = "INVALID_FILTER_CRITERIA";
    ClientExceptionEntityTypeEnum["POSTCOULDNOTBECREATED"] = "POST_COULD_NOT_BE_CREATED";
    ClientExceptionEntityTypeEnum["POSTALREADYLIKED"] = "POST_ALREADY_LIKED";
    ClientExceptionEntityTypeEnum["COMMENTALREADYLIKED"] = "COMMENT_ALREADY_LIKED";
    ClientExceptionEntityTypeEnum["POSTALREADYUNLIKED"] = "POST_ALREADY_UNLIKED";
    ClientExceptionEntityTypeEnum["COMMENTALREADYUNLIKED"] = "COMMENT_ALREADY_UNLIKED";
    ClientExceptionEntityTypeEnum["VEHICLENOTINOPERATINGHOURS"] = "VEHICLE_NOT_IN_OPERATING_HOURS";
    ClientExceptionEntityTypeEnum["DEFAULTTRADINGCATEGORYMUSTNOTBEDELETED"] = "DEFAULT_TRADING_CATEGORY_MUST_NOT_BE_DELETED";
    ClientExceptionEntityTypeEnum["DEFAULTSUGGESTIONCATEGORYMUSTNOTBEDELETED"] = "DEFAULT_SUGGESTION_CATEGORY_MUST_NOT_BE_DELETED";
    ClientExceptionEntityTypeEnum["SUGGESTIONWORKERALREADYWORKINGONSUGGESTION"] = "SUGGESTION_WORKER_ALREADY_WORKING_ON_SUGGESTION";
    ClientExceptionEntityTypeEnum["SUGGESTIONWORKERNOTWORKINGONSUGGESTION"] = "SUGGESTION_WORKER_NOT_WORKING_ON_SUGGESTION";
    ClientExceptionEntityTypeEnum["SUGGESTIONSTATUSCHANGEINVALID"] = "SUGGESTION_STATUS_CHANGE_INVALID";
    ClientExceptionEntityTypeEnum["SUGGESTIONCANNOTBEDELETED"] = "SUGGESTION_CANNOT_BE_DELETED";
    ClientExceptionEntityTypeEnum["EMAILADDRESSINVALID"] = "EMAIL_ADDRESS_INVALID";
    ClientExceptionEntityTypeEnum["PHONENUMBERINVALID"] = "PHONE_NUMBER_INVALID";
    ClientExceptionEntityTypeEnum["SHOPNOTDELETABLE"] = "SHOP_NOT_DELETABLE";
    ClientExceptionEntityTypeEnum["OAUTHIDREGISTRATIONALREADYEXISTS"] = "OAUTH_ID_REGISTRATION_ALREADY_EXISTS";
    ClientExceptionEntityTypeEnum["RESENDVERIFICATIONEMAILNOTPOSSIBLE"] = "RESEND_VERIFICATION_EMAIL_NOT_POSSIBLE";
    ClientExceptionEntityTypeEnum["GROUPALREADYEXISTS"] = "GROUP_ALREADY_EXISTS";
    ClientExceptionEntityTypeEnum["GROUPMEMBERSHIPADMINREMOVALNOTPOSSIBLE"] = "GROUP_MEMBERSHIP_ADMIN_REMOVAL_NOT_POSSIBLE";
    ClientExceptionEntityTypeEnum["UNSPECIFIEDAUTHORIZATIONERROR"] = "UNSPECIFIED_AUTHORIZATION_ERROR";
    ClientExceptionEntityTypeEnum["ROLEMANAGEMENTNOTALLOWED"] = "ROLE_MANAGEMENT_NOT_ALLOWED";
    ClientExceptionEntityTypeEnum["NOTAUTHORIZED"] = "NOT_AUTHORIZED";
    ClientExceptionEntityTypeEnum["PERSONVERIFICATIONSTATUSINSUFFICIENT"] = "PERSON_VERIFICATION_STATUS_INSUFFICIENT";
    ClientExceptionEntityTypeEnum["EMAILALREADYREGISTERED"] = "EMAIL_ALREADY_REGISTERED";
    ClientExceptionEntityTypeEnum["OAUTHEMAILALREADYREGISTERED"] = "OAUTH_EMAIL_ALREADY_REGISTERED";
    ClientExceptionEntityTypeEnum["EMAILCHANGENOTPOSSIBLE"] = "EMAIL_CHANGE_NOT_POSSIBLE";
    ClientExceptionEntityTypeEnum["PASSWORDCHANGENOTPOSSIBLE"] = "PASSWORD_CHANGE_NOT_POSSIBLE";
    ClientExceptionEntityTypeEnum["PERSONALREADYEXISTS"] = "PERSON_ALREADY_EXISTS";
    ClientExceptionEntityTypeEnum["WRONGCARRIERCANCELLED"] = "WRONG_CARRIER_CANCELLED";
    ClientExceptionEntityTypeEnum["WRONGCARRIERDELIVERED"] = "WRONG_CARRIER_DELIVERED";
    ClientExceptionEntityTypeEnum["WRONGLOCATIONDELIVERED"] = "WRONG_LOCATION_DELIVERED";
    ClientExceptionEntityTypeEnum["WRONGCARRIERPICKUP"] = "WRONG_CARRIER_PICKUP";
    ClientExceptionEntityTypeEnum["WRONGRECEIVERRECEIVED"] = "WRONG_RECEIVER_RECEIVED";
    ClientExceptionEntityTypeEnum["CHATSENDERNOTCARRIER"] = "CHAT_SENDER_NOT_CARRIER";
    ClientExceptionEntityTypeEnum["TRANSPORTNOTASSIGNEDTOCURRENTPERSON"] = "TRANSPORT_NOT_ASSIGNED_TO_CURRENT_PERSON";
    ClientExceptionEntityTypeEnum["ACCESSEDANOTHERSRESOURCES"] = "ACCESSED_ANOTHERS_RESOURCES";
    ClientExceptionEntityTypeEnum["PERSONNOTCHATPARTICIPANT"] = "PERSON_NOT_CHAT_PARTICIPANT";
    ClientExceptionEntityTypeEnum["POSTACTIONNOTALLOWED"] = "POST_ACTION_NOT_ALLOWED";
    ClientExceptionEntityTypeEnum["COMMENTACTIONNOTALLOWED"] = "COMMENT_ACTION_NOT_ALLOWED";
    ClientExceptionEntityTypeEnum["GROUPCONTENTNOTACCESSIBLE"] = "GROUP_CONTENT_NOT_ACCESSIBLE";
    ClientExceptionEntityTypeEnum["NOTAUTHENTICATED"] = "NOT_AUTHENTICATED";
    ClientExceptionEntityTypeEnum["WRONGCHECK"] = "WRONG_CHECK";
    ClientExceptionEntityTypeEnum["POOLINGSTATIONFULL"] = "POOLING_STATION_FULL";
    ClientExceptionEntityTypeEnum["POOLINGSTATIONBOXCANNOTBEOPENED"] = "POOLING_STATION_BOX_CANNOT_BE_OPENED";
    ClientExceptionEntityTypeEnum["UNSPECIFIEDEXTERNALERROR"] = "UNSPECIFIED_EXTERNAL_ERROR";
    ClientExceptionEntityTypeEnum["DELIVERYNOTINPOOLINGSTATION"] = "DELIVERY_NOT_IN_POOLING_STATION";
    ClientExceptionEntityTypeEnum["DELIVERYALREADYINPOOLINGSTATION"] = "DELIVERY_ALREADY_IN_POOLING_STATION";
    ClientExceptionEntityTypeEnum["DELIVERYSTILLINPOOLINGSTATION"] = "DELIVERY_STILL_IN_POOLING_STATION";
    ClientExceptionEntityTypeEnum["DELIVERYSTATUSINVALID"] = "DELIVERY_STATUS_INVALID";
    ClientExceptionEntityTypeEnum["TRANSPORTASSIGNMENTSTATUSINVALID"] = "TRANSPORT_ASSIGNMENT_STATUS_INVALID";
    ClientExceptionEntityTypeEnum["DELIVERYSTATUSALREADYREACHED"] = "DELIVERY_STATUS_ALREADY_REACHED";
    ClientExceptionEntityTypeEnum["UNSPECIFIEDSTATUSCONFLICT"] = "UNSPECIFIED_STATUS_CONFLICT";
    ClientExceptionEntityTypeEnum["POOLINGSTATIONBOXNOTCLOSED"] = "POOLING_STATION_BOX_NOT_CLOSED";
    ClientExceptionEntityTypeEnum["DELIVERYPICKEDUPATWRONGLOCATION"] = "DELIVERY_PICKED_UP_AT_WRONG_LOCATION";
    ClientExceptionEntityTypeEnum["ACCOUNTENTRYALREADYBOOKED"] = "ACCOUNT_ENTRY_ALREADY_BOOKED";
    ClientExceptionEntityTypeEnum["ACCOUNTSHORTAGE"] = "ACCOUNT_SHORTAGE";
    ClientExceptionEntityTypeEnum["RESERVATIONNOTEXISTING"] = "RESERVATION_NOT_EXISTING";
    ClientExceptionEntityTypeEnum["RESERVATIONSNOTMATCHING"] = "RESERVATIONS_NOT_MATCHING";
    ClientExceptionEntityTypeEnum["GROUPMEMBERSHIPALREADYPENDING"] = "GROUP_MEMBERSHIP_ALREADY_PENDING";
    ClientExceptionEntityTypeEnum["NOTMEMBEROFGROUP"] = "NOT_MEMBER_OF_GROUP";
    ClientExceptionEntityTypeEnum["PERSONHASNOPENDINGNEWEMAIL"] = "PERSON_HAS_NO_PENDING_NEW_EMAIL";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGHASDIFFERENTTYPE"] = "USER_GENERATED_CONTENT_FLAG_HAS_DIFFERENT_TYPE";
    ClientExceptionEntityTypeEnum["UNSPECIFIEDERROR"] = "UNSPECIFIED_ERROR";
    ClientExceptionEntityTypeEnum["VERSIONPARSINGFAILED"] = "VERSION_PARSING_FAILED";
    ClientExceptionEntityTypeEnum["ENCRYPTIONFAILED"] = "ENCRYPTION_FAILED";
    ClientExceptionEntityTypeEnum["DATADEPENDENCYUNSATISFIABLE"] = "DATA_DEPENDENCY_UNSATISFIABLE";
    ClientExceptionEntityTypeEnum["MASTERDATADELETIONFAILED"] = "MASTER_DATA_DELETION_FAILED";
    ClientExceptionEntityTypeEnum["DATAPRIVACYPROCESSINGFAILED"] = "DATA_PRIVACY_PROCESSING_FAILED";
    ClientExceptionEntityTypeEnum["STATISTICSPROCESSINGFAILED"] = "STATISTICS_PROCESSING_FAILED";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGENTITYDELETIONFAILED"] = "USER_GENERATED_CONTENT_FLAG_ENTITY_DELETION_FAILED";
    ClientExceptionEntityTypeEnum["USERGENERATEDCONTENTFLAGINVALID"] = "USER_GENERATED_CONTENT_FLAG_INVALID";
    ClientExceptionEntityTypeEnum["UNEXPECTEDEVENTOCCURRED"] = "UNEXPECTED_EVENT_OCCURRED";
    ClientExceptionEntityTypeEnum["REQUESTPROCESSINGTIMEOUT"] = "REQUEST_PROCESSING_TIMEOUT";
})(ClientExceptionEntityTypeEnum = exports.ClientExceptionEntityTypeEnum || (exports.ClientExceptionEntityTypeEnum = {}));
